<template>
  <div class="vx-row mb-2 -mt-1">
    <div class="vx-col w-full">
      <span class="text-xs"> &nbsp;</span>
      <vs-row>
        <h6 class="pt-3">Date From</h6> &nbsp;
        <flat-pickr v-model="dateFrom" />
        <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-x" data-clear @click="dateFrom = ''">
        </vs-button>
        &nbsp;
        <h6 class="pt-3">To</h6> &nbsp;

        <flat-pickr v-model="dateTo" />
        <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-x" data-clear @click="dateTo = ''">
        </vs-button>
      </vs-row>
      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>

    </div>
  </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { sidebarMixin } from "../sidebarMixin";
export default {
  mixins: [sidebarMixin],
  components: {
    flatPickr,
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => { },
      required: true,
    },
    value: String,
    validation: "",
  },
  data() {
    return {
      localVal: null,
      name: "",
      dateFrom: "",
      dateTo: "",
    };
  },

  methods: {
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
  },
  computed: {
    dateRange() {
      return [this.dateFrom, this.dateTo];
    },
  },
  created() {
    if (this.value == undefined) {
      if (this.structure.value != "-") {
        // var thedate = "";
        // var split = thedate.toISOString().split("T");
        this.localVal = '';
      } else {
        this.localVal = "";
        this.$emit("error", { index: this.index, value: true });
        this.$emit("input", { index: this.index, value: this.localVal });
      }
    } else {
      this.localVal = this.value;
    }

    if (this.localVal != "") {
      this.$emit("error", { index: this.index, value: true });

      this.$emit("input", { index: this.index, value: this.localVal });
    }

    this.$watch("dateRange", (value) => {
      if (value != "") {
        this.$emit("input", { index: this.index, value: value });
        this.$emit("error", { index: this.index, value: true });
      } else {
        this.$emit("error", { index: this.index, value: false });
      }
    });
  },
};
</script>
